export default function NewslettersEntries() {
  return (
    <table id="filetable">
      <tr>
        <th>File Name</th>
        <th>Date Posted</th>
      </tr>
       {/*Start File*/}
       <tr>
        <td>
          <a href="../docs/newsletters/newsletter-2025-spring.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp;Spring 2025 Newsletter
            </a>
        </td>
        <td>08/6/2025</td>
      </tr>
      {/*End File*/}
    </table>
  );
}